import React from 'react';
import { useUnit } from 'hooks/units/index';
import useCountdownTimer from 'hooks/useCountdownTimer';
import { Button } from 'reactstrap';

import { UNIT_STATUS } from 'constants/constants';
import ButtonComplete from './ButtonComplete';
import ButtonCompleted from './ButtonCompleted';

const TimeComplete = () => {
  const unitSelected = useUnit();
  const { minutes, seconds } = useCountdownTimer(
    unitSelected?.complete?.data?.second * 1000,
  );

  if (unitSelected.status === UNIT_STATUS.COMPLETED) {
    return (
      <div className="text-center">
        <ButtonCompleted />
      </div>
    );
  }

  if (minutes < 0 && seconds < 0) {
    return (
      <div className="text-center">
        <ButtonComplete />
      </div>
    );
  }

  return (
    <div className="text-center">
      <Button.Ripple className="round" color="primary" disabled>
        Completes in {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
      </Button.Ripple>
    </div>
  );
};

export default TimeComplete;
